import type { FaireProductEntity } from "../../entity_types/product";

export const p_9rff8ef9: FaireProductEntity = {
  token: "p_9rff8ef9",
  type: "product",
  name: "Thank You In Daisies",
  brandToken: "b_1fcb3396",
  brandName: "Dear Hancock",
  imageUrl:
    "https://cdn.faire.com/fastly/90498b5f11bb95b21b7dec5c6df0a676cb444499f0dfafe8d1a6dec89f06c359.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a141c14a9191d4ee7d0ae9aea089dd8182699d25c7ad4fa6c6d3501965f70c37.jpeg",
  ],
  priceDollars: 3,
  description:
    "A delicate hand lettered thank you card created from daisies.\n\n• Size - 4.25” x 5.5”.\n• Printed on natural off white paper with a matching off-white envelope.\n• Blank interior for personal message.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:54.662Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
